// Sends the current Microsoft Clarity ids with our own requests (X-Clarity-Session),
// so the backend can put them in logs and Amplitude events and support can open the
// recording of a booking action. Clarity is only loaded in production
// (app/views/layouts/application.html.erb); everywhere else no header is sent.

export const CLARITY_SESSION_HEADER = 'X-Clarity-Session';

let claritySession = null;
let subscribed = false;

function subscribe() {
  if (subscribed || typeof window === 'undefined' || typeof window.clarity !== 'function') return;
  subscribed = true;

  try {
    // wait = false: answer as soon as the ids exist; recall = true: answer again
    // whenever Clarity starts a new session in this tab.
    window.clarity(
      'metadata',
      (data) => {
        if (data && data.userId && data.sessionId) {
          claritySession = `${data.userId}/${data.sessionId}`;
        }
      },
      false,
      true
    );
  } catch (e) {
    subscribed = false;
  }
}

// A custom header on a cross-origin request would trigger a CORS preflight,
// so it only goes to this app.
function isSameOrigin(url) {
  if (typeof url !== 'string' || typeof window === 'undefined') return false;

  try {
    return new URL(url, window.location.href).origin === window.location.origin;
  } catch (e) {
    return false;
  }
}

export function claritySessionHeaders(url) {
  subscribe();
  if (!claritySession || !isSameOrigin(url)) return {};

  return { [CLARITY_SESSION_HEADER]: claritySession };
}

export function resetClaritySessionForTests() {
  claritySession = null;
  subscribed = false;
}
